/**
 * 画面依存しないドメイン特有のState扱うモジュール群
 */
import { combineReducers } from 'redux';

import planReducer from './plan';
import purchaseReducer from './purchase';
import usersReducer from './user';
import purchaseSessionReducer from './purchaseSession';
import terminalReducer from './terminal';
import lendingUserReducer from './lendingUser';
import deviceActivateReducer from './deviceActivate';

const domainReducer = combineReducers({
  plan: planReducer,
  purchase: purchaseReducer,
  purchaseSession: purchaseSessionReducer,
  user: usersReducer,
  terminal: terminalReducer,
  lendingUser: lendingUserReducer,
  deviceActivate: deviceActivateReducer
});

export default domainReducer;
